export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5210.23394fce.jpg";